interface RolePillProps {
  role: "owner" | "admin" | "member";
}

export function RolePill({ role }: RolePillProps) {
  const roleConfig = {
    owner: {
      label: "Owner",
      className: "bg-primary text-white" // Solid brand fill - highest authority
    },
    admin: {
      label: "Admin",
      className: "bg-primary/10 text-primary dark:bg-primary/30 dark:text-white" // Brand tint - elevated access
    },
    member: {
      label: "Member",
      className: "bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-gray-300" // Neutral gray - basic access
    }
  };

  const config = roleConfig[role];

  return (
    <span className={`inline-flex items-center px-1.5 py-px rounded-full text-[10px] font-medium leading-4 ${config.className}`}>
      {config.label}
    </span>
  );
}